import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  employees: {},
  periods: {},
  days: {},
  projects: {},
  isLoading: true,
  updateObject: null,
  openCalculator: "",
  employeeSuggestions: [],
  conflictingProjects: {}
}


export default (state=initState, action) => {
  switch (action.type) {
    case actionConsts.GET_SALARY_OBJECT_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
    });
    case actionConsts.GET_SALARY_OBJECT_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
        employees: {
          $set: action.employees
        },
        days: {
          $set: action.days
        },
        projects: {
          $set: action.projects
        },
        periods: {
          $set: action.periods
        },
        conflictingProjects: {
          $set: action.conflictingProjects
        }
    });
    case actionConsts.UPDATE_DAY_REQUEST:
      return update(state, {
        days: {
          [action.dayId]: {
            normalHours: {
              $set: action.normalHours
            },
            supplementRate: {
              $set: action.supplementRate
            },
            supplementHours: {
              $set: action.supplementHours
            },
            shackNew: {
              $set: action.shackNew
            },
            mileageNew: {
              $set: action.mileageNew
            }
          }
        },
        employees: {
          [action.updateObject.employeeId]: {
            latestSupplementRate: {
              $set: action.supplementRate
            }
          }
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.UPDATE_DAY_FAILURE:
      return update(state, {
          days: {
            [action.dayId]: {
              $set: action.oldDayState
            }
          }
      });
    case actionConsts.UPDATE_ABSENCE_REQUEST:
      return update(state, {
          days: {
            [action.dayId]: {
              absenceCode:{
                $set: action.absenceCode
              }
            }
          }
      });
    case actionConsts.UPDATE_ABSENCE_FAILURE:
      return update(state, {
          days: {
            [action.dayId]: {
              absenceCode:{
                $set: action.oldAbsence
              }
            }
          }
      });
    case actionConsts.UPDATE_PERIOD_INPUT_REUQEST:
      return update(state, {
        periods: {
          [action.periodId]: {
            [action.inputType]: {
              $set: action.value
            }
          }
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.UPDATE_PERIOD_INPUT_FAILURE:
      return update(state, {
        periods: {
          [action.periodId]: {
            $set: action.oldPeriodState
          }
        }
    });
    case actionConsts.SET_CALCULATOR_OPEN:
      return update(state, {
        openCalculator: {
          $set: action.dayId
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.MARK_DAY_CONFLICTING:
      return update(state, {
        days: {
          [action.dayId]: {
            conflictsWith: {
              $set: action.conflictsWith
            },
            isConflicting: {
              $set: true
            },
            newConflictingProjects: {
              $set: action.newConflictingProjects
            }
          }
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.MARK_DAY_CONFLICT_SOLVED:
      return update(state, {
        days: {
          [action.dayId]: {
            conflictsWith: {
              $set: []
            },
            isConflicting: {
              $set: false
            }
          }
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.GET_EMPLOYEE_SUGGESTIONS_SUCCESS:
      return update(state, {
        employeeSuggestions: {
          $set: action.suggestions
        },
        updateObject: {
          $set: action.updateObject
        }
    });
    case actionConsts.ADD_EMPLOYEE_TO_PROJECT_SUCCESS:
      return update(state, {
        periods: {
          [action.period.id]: {
            $set: action.period
          }
        },
        employees: {
          [action.employee.id]: {
            $set: action.employee
          }
        },
        days: {
          $set: Object.assign({}, state.days, action.days)
        },
        projects: {
          [action.projectId]: {
            periodIds: {
              $push: [action.period.id]
            },
            employeeIds: {
              $push: [action.employee.id]
            }
          }
        }
    });
    case actionConsts.ADD_ALREADY_EXISTING_EMPLOYEE_TO_PROJECT_SUCCESS:
      return update(state, {
        periods: {
          [action.period.id]: {
            $set: action.period
          }
        },
        employees: {
          [action.employee.id]: {
            periodIds: {
              $push: action.employee.periodIds
            }
          }
        },
        days: {
          $set: Object.assign({}, state.days, action.days)
        },
        projects: {
          [action.projectId]: {
            periodIds: {
              $push: [action.period.id]
            },
            employeeIds: {
              $push: [action.employee.id]
            }
          }
        }
    });


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/Project/Salary/reducer.js